export default __webpack_public_path__ + "static/waveform2-2c2ee768d4f8d95661a87ca45663038f.svg";